import { mapState, mapGetters, mapActions } from 'vuex'

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    leftSidebarSize: (state) => state.leftSidebarSize,
    menuPosition: (state) => state.menuPosition,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType','changeLeftSidebarSize', 'changeTopbar', 'changeLoaderValue', 'changeMenuPosition'])

export const authFackMethods = mapActions('authfack', ['login', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const apiConfig = {
  apiUrl: process.env.VUE_APP_APIURL,
};